import React from 'react';

interface EmojiIconProps {
  iconUrl?: string;
  size?: number | string; // optional size prop
  className?: string;
}

const EmojiIcon: React.FC<EmojiIconProps> = ({ iconUrl, size = 24, className = '' }) => {
  if (!iconUrl) return null;

  return (
    <span
      className={className}
      style={{
        fontSize: typeof size === 'number' ? `${size}px` : size,
        lineHeight: 1,
      }}
    >
      {iconUrl}
    </span>
  );
};

export default EmojiIcon;
